import React from 'react'
import { DiversityTable as DiversityTableDS } from '@diversioteam/diversio-ds'
import { Link } from 'react-router-dom'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'
import { useDiversityTable } from 'hooks/useDiversityTable'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'

const DiversityTableWithoutEB = () => {
    const { isLoading, data } = useDiversityTable()

    if (!data || isLoading) {
        return null
    }

    return (
        <div className="ddsi-card">
            <DiversityTableDS
                {...data}
                title="Diversity"
                titleWrapperProps={{
                    component: Link,
                    to: generateCompanyURI('/analyze2/diversity'),
                }}
                data-joyride="home-diversity-table"
            />
        </div>
    )
}

export const DiversityTable = withErrorBoundary(DiversityTableWithoutEB, {})
